var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    { class: _vm.givenClass, attrs: { id: "table-component" } },
    [
      _c(
        "h4",
        [
          _vm._v(" " + _vm._s(_vm.title) + " "),
          _c(
            "b-tooltip",
            {
              staticClass: "is-info",
              attrs: { label: "Copiar al portapapeles", position: "is-bottom" },
            },
            [
              _vm.value.length
                ? _c(
                    "button",
                    {
                      staticClass: "button is-info is-outlined",
                      on: { click: _vm.copy },
                    },
                    [
                      _c("span", { staticClass: "icon" }, [
                        _c("i", { staticClass: "fas fa-clipboard fa-lg" }),
                      ]),
                    ]
                  )
                : _vm._e(),
            ]
          ),
        ],
        1
      ),
      _c("b-table", {
        class: _vm.givenClass,
        attrs: {
          id: _vm.id,
          data: _vm.data,
          columns: _vm.columns,
          paginated: _vm.paginated,
          "per-page": _vm.perPage,
          bordered: _vm.bordered,
          narrowed: _vm.narrowed,
          "mobile-cards": _vm.mobileCards,
          striped: _vm.striped,
          hoverable: _vm.hoverable,
          focusable: _vm.focusable,
          size: _vm.size,
          "sticky-header": _vm.stickyHeader,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }